import { getTemplatesByDataType } from "../../../../../constants"
import { ConnectorDirection } from "../../../../../../types"

interface UseTemplateLoaderProps {
  dataType: "lead" | "subscription" | "pending_subscription"
  direction: ConnectorDirection
  setFormField: (name: string, val: any) => void
  currentConfig?: Record<string, any>
}

export const useTemplateLoader = ({
  dataType,
  direction,
  setFormField,
  currentConfig
}: UseTemplateLoaderProps) => {
  const availableTemplates = getTemplatesByDataType(dataType, direction)

  const loadTemplate = (templateName: string) => {
    const template = availableTemplates.find(t => t.name === templateName)

    if (!template) {
      return
    }

    // Templates are stored in the new array format with incoming_key/outgoing_key
    // No inversion needed — just use as-is
    setFormField("field_mapping", template.field_mapping)

    setFormField("type", template.type)

    if (template.template) {
      setFormField("template", template.template)
    }

    if (template.content_type) {
      setFormField("config", {
        ...currentConfig,
        content_type: template.content_type
      })
    }
  }

  return {
    availableTemplates,
    loadTemplate
  }
}
